import { addSafetyReviewBoardMeetingForm, generateSafetyReviewBoardMeetingSummary } from "./actions.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue";
import ItemView from "../../../components/ItemView/ItemView.vue";
import attachables from "./attachables.js";

export default [{
    "path": "/SafetyManagement/SafetyReviewBoardMeetings",
    "component": { ...ItemListView },
    "name": "Safety Review Board Meetings",
    "meta": {
        "app": "SafetyManagement",
        "sideNav": true,
        "appSwitcher": false,
        "sideNavSection": "Safety and Risk Management",
        "name": "Safety Review Board Meetings",
        "tableSettings": "SafetyReviewBoardMeetings",
        "dataPath": "SafetyManagement/SafetyReviewBoardMeetings",
        "selectionRoute": "SafetyManagement/SafetyReviewBoardMeetings/{ID}",
        "menuActions": [{
            "label": "Add Safety Review Board Meeting",
            "action": addSafetyReviewBoardMeetingForm
        }]
    }
}, {
    "path": "/SafetyManagement/SafetyReviewBoardMeetings/:id",
    "component": ItemView,
    "name": "Safety Review Board Meeting Entry",
    "meta": {
        "app": "SafetyManagement",
        "name": "Safety Review Board Meeting Entry",
        "dataPath": "SafetyManagement/SafetyReviewBoardMeetings",
        "title": (item) => `Safety Review Board Meeting: ${item.Number}`,
        "dataFields": [{
            "label": "Number",
            "key": "Number"
        }, {
            "label": "Title",
            "key": "Title",
            "class": "md:col-span-2"
        }, {
            "label": "Date Created",
            "key": "Date.Created",
        }, {
            "label": "Date of Meeting",
            "key": "Date.Meeting",
        }, {
            "label": "Meeting Minutes",
            "key": "MeetingMinutesFile",
            "type": "text",
            "actionButton": true,
            "actionText": "Download",
            async action({ pageItem, db }) {
                let url = await db.download(`Database/SafetyReviewBoardMeetings/${pageItem.ID}/MeetingMinutes/${pageItem.MeetingMinutesFile}`);
                window.open(url, "fileView", "popup");
            }
        }, {
            "label": "Summary",
            "key": "Summary",
            "type": "text",
            "grow": true,
            "class": "md:col-span-3"
        }],
        "menuActions": [{
            "label": "Generate Summary",
            "action": generateSafetyReviewBoardMeetingSummary,
        }],
        "attachedItems": {
            "Details": {
                "attachables": attachables
            }
        }
    }
}];
